import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@ifeng-fe/public_method';
import styles from './index.css';

const timeHandler = time => {
    if (!time) return '';
    const reg = /\//g;
    const charTime = time.replace(reg, '-');
    // const splitTime = charTime.split(' ');

    // return splitTime[0];
    return charTime;
};

const addZero = num => {
    if (typeof num !== 'number') return console.error('传入的不是数字类型');

    return num < 10 ? `0${num}` : num;
};
const formatTime = time => {
    const t = Number(time);
    const date = new Date(t);
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const d = date.getDate();
    const h = date.getHours();
    const f = date.getMinutes();
    const s = date.getSeconds();

    return `${y}-${addZero(m)}-${addZero(d)} ${addZero(h)}:${addZero(f)}:${addZero(s)}`;
};

class PersonInfo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        share: PropTypes.bool,
        fromPage: PropTypes.string,
    };

    isTimeStamp = time => {
        const reg = /^[0-9]+$/g;

        return reg.test(time);
    };

    render() {
        const { content, share, fromPage } = this.props;

        const { lev, title, userimg, nickname, add_time, ip_from, like } = content;

        return (
            <div>
                <div className={styles.home_top}>
                    <div className={styles.infohead}>
                        <div className={styles.head}>
                            <img src={formatImage(userimg)} />
                        </div>
                        <div className={styles.i_info}>
                            <div className={styles.i_info_p}>
                                <span className={styles.name}>{nickname}</span>
                                {fromPage !== 'home' && lev >= 0 ? (
                                    <span className={styles.level}>·LV{lev}&nbsp;</span>
                                ) : (
                                    ''
                                )}
                                {title ? <span className={styles.title}>{title}</span> : ''}
                            </div>
                            <div className={styles.i_info_d}>
                                {ip_from ? <span className={styles.address}>{ip_from}</span> : ''}
                                <span className={styles.time}>
                                    {this.isTimeStamp(add_time) ? formatTime(add_time * 1000) : timeHandler(add_time)}
                                </span>
                            </div>
                        </div>
                        {share ? (
                            <div className={styles.share}>
                                <span>{like}</span>
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(PersonInfo);
